import React from 'react'
import './Home.scss'
import './Custom.scss'
import hero_img from '../assets/hero_img.png'


const Home = () => {

    


  return (
    <div id="home" className='home_section'>
        <div className="container h-100 ">
            <div className="row h-100 text-start d-flex flex-column-reverse flex-md-row justify-content-between align-items-center ">
                <div className="col-md-6 w-md-50 col-12 home_text">
                    <h1 data-aos="fade-up" className='main_heading'>Building Digital <br /> Experiences with <br /> Code & Creativity</h1>
                    <h2 data-aos="fade-up" className="my-4 mb-5">Crafting pixel-perfect frontend solutions that blend code, design, and user experience into captivating digital journeys.</h2>
                    <div data-aos="fade-up" className="home_buttons_cont mb-5 mb-md-0">
                        <a className='custom_btn_1 up_1 frankie me-md-3 me-0' href="#GetInTouch">Contact</a>
                        <a className='custom_btn_1 up_1 frankie' href="#Projects">Projects</a>
                    </div>
                </div>
                <div data-aos="fade-up" className="col-md-6 col-12">
                    <img className='w-100 ' src={hero_img} alt="" />
                </div>
            </div>
        </div>
    </div>
  )
}

export default Home